import React, { Component } from 'react';
import FireBase from 'firebase/app';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import Paper from 'material-ui/Paper';
import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import FileUpload from '../components/FileUpload';
import firebase from '../firebase';
import { DateFormat } from "../utils/DateUtils";
import uuid from 'uuid/v1';


const styles = {
  root: {
    padding: 20,
    margin: '0 auto'
  },
  form: {
  },
  toggleStyle: {
    marginTop: 10,
    marginBottom:10,
  },
  paper: {
    padding: 20,
  },
  gridList: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
  },
  saveButton: {
    marginTop: 15,
  }
};


class EditCoupon extends Component{
  state = {
    title: '',
    referenceCode: '',
    description: '',
    active: true,
    photoUrl: '',
    uploadProgress:0,
    restaurantId: null,
    uploading: false,
    expirationDate: null,
    couponId: null,
    createMode: false,
    sendPush: true,
  };

  async componentDidMount() {
    const { params } = this.props;
    const restaurantId = params.restaurantId;
    const couponId = params.couponId;

    this.couponPath = firebase.firestore()
      .collection('restaurant')
      .doc(restaurantId)
      .collection('specials');


    if(!couponId) {
      this.setState({
        createMode: true,
        restaurantId,
      });
      return;
    }

    try {
      const couponSnap = await this.couponPath.doc(couponId).get();

      const coupon = couponSnap.data();

      console.log(coupon.expirationDate)

      this.setState({
        ...coupon,
        expirationDate : coupon.expirationDate && coupon.expirationDate.toDate(),
        couponId,
        restaurantId,
      });
    } catch (e) {
      console.log({ e })
    }
  }

  handleSubmit = async () => {
    const { createMode, title, referenceCode, description, active, photoUrl, expirationDate, couponId, sendPush } = this.state;

    const coupon = { title, referenceCode, description, active, photoUrl, expirationDate, sendPush };

    if(createMode) {
      await this.couponPath.add(coupon)
    } else {
      await this.couponPath.doc(couponId).update(coupon);
    }
    this.props.router.goBack();
  };

  handleImageDrop = (accepted, reject) => {
    const { restaurantId } = this.state;
    const file = accepted[0];
    const metadata = {
      contentType: file.type,
    };

    const uploadTask = firebase.storage().ref(`/restaurants/${restaurantId}/coupons/${uuid()}${file.name}`)
      .put(file, metadata);

    uploadTask.on(FireBase.storage.TaskEvent.STATE_CHANGED, snapshot => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      this.setState({
        uploadProgress: progress,
        uploading: true,
      });
    }, error => {

    }, () => {
      uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
        this.setState({
          photoUrl: downloadURL,
          uploading: false
        });
      });
    });
  };

  render() {
    const { title, referenceCode, description, expirationDate, active, photoUrl, uploading, createMode, sendPush } = this.state;

    return (
      <div style={styles.root}>
        <h1>{ createMode ? 'Create Deal' : 'Edit Deal'}</h1>
        <form style={styles.form}>
          <Paper style={styles.paper}>
            <TextField
              hintText="Short description for this deal"
              value={title}
              onChange={e => this.setState({ title: e.target.value })}
              fullWidth
              required
              floatingLabelText="Title"
            />
            <TextField
              hintText="A longer description for this deal"
              value={description}
              onChange={e => this.setState({ description: e.target.value })}
              fullWidth
              required
              floatingLabelText="Description"
            />
            <TextField
              hintText="Internal identifer for this deal"
              value={referenceCode}
              onChange={e => this.setState({ referenceCode: e.target.value })}
              fullWidth
              required
              floatingLabelText="Reference Code"
            />

            <DatePicker
              hintText="Leave empty if deal doesn't expire"
              value={expirationDate}
              floatingLabelText="Expiration Date"
              fullWidth
              onChange={(e, expirationDate) => this.setState({ expirationDate })}
              style={{ marginRight: 10 }}
              formatDate={DateFormat}
            />

            <Toggle
              label="Send push notification"
              toggled={sendPush}
              onToggle={(e, sendPush) => this.setState({ sendPush })}
              style={styles.toggleStyle}
              disabled={!createMode}
              labelPosition="right"
            />

            <Toggle
              label="Available"
              labelPosition="right"
              toggled={active}
              onToggle={(e, active) => this.setState({ active })}
              style={styles.toggleStyle}
            />

          </Paper>
          <h2>Image</h2>
          <Paper
            style={{ padding: 15, display: 'flex' }}
          >
            <FileUpload
              multiple={false}
              onDrop={this.handleImageDrop}
              accept="image/png, image/jpeg"
              uploadProgress={this.state.uploadProgress}
              uploading={this.state.uploading}
            />
            <img src={photoUrl} style={{ height: 200, marginLeft: 20 }} />
          </Paper>
          <RaisedButton
            label="Cancel"
            style={{ marginRight: 8 }}
            onTouchTap={() => this.props.router.goBack()}
          />
          <RaisedButton
            label="Save"
            style={styles.saveButton}
            onTouchTap={this.handleSubmit}
            secondary
          />

        </form>
      </div>
    );
  }
}

export default EditCoupon;


// WEBPACK FOOTER //
// ./src/pages/EditCoupon.js